import css from 'styled-jsx/css';

const styles = css``;

export default styles;